import { render, staticRenderFns } from "./SteamItem.vue?vue&type=template&id=3a47e967&scoped=true&"
import script from "./SteamItem.vue?vue&type=script&lang=ts&"
export * from "./SteamItem.vue?vue&type=script&lang=ts&"
import style0 from "./SteamItem.vue?vue&type=style&index=0&id=3a47e967&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a47e967",
  null
  
)

export default component.exports
import QIntersection from 'quasar/src/components/intersection/QIntersection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIntersection,QImg});
